import Select from "common/components/Select";
import axios from "common/configs/axiosConfigs";
import {
  FURNISHED_OPTIONS,
  LEAD_TYPE_OPTIONS,
  OPTIONS,
  PURPOSE_OPTIONS,
  SOURCE_OPTIONS,
} from "common/constants/enums";
import CreateContactForm from "pages/properties/components/CreateContactForm";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CreateLead = () => {
  const navigate = useNavigate();
  const companyId = JSON.parse(localStorage.getItem("user-auth"))?.company_id;

  const [isOpen, setIsOpen] = useState(false);
  const [assignees, setAssignees] = useState([]);
  const ASSIGNEE_OPTIONS = assignees?.map((o) => ({
    value: o?.id,
    label: `${o?.name} - ${
      o?.role_id === 1 ? "Super Admin" : o?.role_id === 2 ? "Administrator" : "Staff Member"
    }`,
  }));
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({ step1: {}, step2: {}, step3: {}, step4: {} });
  const [values, setValues] = useState({});
  const [contacts, setContacts] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [propertyTypes, setPropertyTypes] = useState([]);
  const propertySubTypes = propertyTypes?.subtype?.filter(
    (type) => formData?.step2?.propertyType === type?.property_type_id.toString()
  );
  const contactOptions = contacts?.map((c) => ({
    label: `${c?.first_name} ${c?.last_name} - ${c?.phone}`,
    value: c?.id,
  }));
  const staffOptions = staffList?.map((c) => ({
    label: `${c?.name} ${c?.role_id === 2 ? "(Administrator)" : ""}`,
    value: c?.id,
  }));
  const FORM_DATA = {
    step1: { contactId: "" },
    step2: { saleType: "", propertyType: "", propertySubType: "" },
    step3: {
      purpose: "",
      furnished: "",
      min_bug: "",
      max_bug: "",
      location: "",
      configuration: "",
    },
    step4: {},
  };
  const isStepValid = () => {
    const currentStepData = formData[`step${currentStep}`];
    return Object.values(currentStepData).every((field) => field);
  };
  const handleChange = ({ target: { name, value } }) => {
    setValues((prev) => ({ ...prev, [name]: value }));
  };
  const handleFormInput = ({ target: { name, value, isMulti } }) => {
    setFormData({
      ...formData,
      [`step${currentStep}`]: {
        ...formData[`step${currentStep}`],
        [name]: value,
      },
    });
  };
  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const previousStep = () => {
    setCurrentStep(currentStep - 1);
  };
  const onClose = () => {
    setIsOpen(false);
  };
  const getAssignee = async () => {
    try {
      const { data } = await axios.post("", {
        action: "getStaffList",
        companyId,
      });
      if (data?.success) {
        setAssignees(data?.data);
      }
    } catch (err) {
      console.error("ERROR:", err);
    }
  };
  const handleSubmitLead = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(
        "",
        {
          action: "createLead",
          companyId,
          ...Object.assign({}, ...Object.values(formData)),
        },
        {}
      );
      if (data?.success) {
        toast.success(data?.msg);
        navigate("/leads");
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setFormData(FORM_DATA);
    }
  };
  const getContacts = async (isNew) => {
    try {
      const { data } = await axios.post("", { action: "getContact", companyId });
      if (data.success) {
        setContacts(data?.data);
        isNew && setValues((v) => ({ ...v, contactId: data?.data?.at(-1)?.id }));
      }
    } catch (err) {
      console.error("ERROR:", err);
    }
  };
  const getPropertyTypes = async () => {
    try {
      const { data } = await axios.post("", { action: "getPropertyType" });
      if (data.success) {
        setPropertyTypes(data);
      }
    } catch (err) {
      console.error("ERROR:", err);
    }
  };
  const getStaffList = async () => {
    try {
      const { data } = await axios.post("", { action: "getStaffList", companyId });
      if (data.success) {
        setStaffList(data.data);
      }
    } catch (err) {
      console.error("ERROR:", err);
    }
  };
  useEffect(() => {
    getPropertyTypes();
    getStaffList();
    getContacts();
    getAssignee();
    setFormData(FORM_DATA);
  }, []);
  return (
    <>
      <section>
        <h4 className="page-title">Create Lead</h4>
        <form onSubmit={handleSubmitLead}>
          <div className={`card mt-2 ${isStepValid() || currentStep > 1 ? "" : ""}`}>
            <small className="text-muted">Step 1</small>
            <h6>CONTACT INFORMATION</h6>
            <div className={`step ${currentStep === 1 ? "d-flex" : "d-none"}`}>
              <div className="w-50">
                <Select
                  options={contactOptions}
                  name="contactId"
                  value={values.contactId}
                  onChange={(e) => {
                    handleChange(e);
                    handleFormInput(e);
                  }}
                  placeholder="Owner/Landlord"
                />
              </div>
              <button type="button" className="btn btn-dark ms-3" onClick={() => setIsOpen(true)}>
                Create Contact
              </button>
            </div>
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="ms-3 btn btn-primary"
                onClick={nextStep}
                disabled={!isStepValid()}
              >
                Next
              </button>
            </div>
          </div>

          <div className={`card mt-2 ${isStepValid() || currentStep > 2 ? "" : ""}`}>
            <small className="text-muted">Step 2</small>
            <h6>REQUIREMENTS</h6>
            <div className={`step row gy-4 ${currentStep === 2 ? "" : "d-none"}`}>
              <div className="col-12">
                <span className="label">Property for</span>
                <div className="row radio-btn-group g-3">
                  <label>
                    <input
                      type="radio"
                      name="saleType"
                      value="rent"
                      onChange={handleFormInput}
                      className="d-none"
                    />
                    <span className="radio-btn">Rent</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="saleType"
                      value="sale"
                      onChange={handleFormInput}
                      className="d-none"
                    />
                    <span className="radio-btn">Sale</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="saleType"
                      value="lease"
                      onChange={handleFormInput}
                      className="d-none"
                    />
                    <span className="radio-btn">Lease</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="saleType"
                      value="pg"
                      onChange={handleFormInput}
                      className="d-none"
                    />
                    <span className="radio-btn">PG</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="saleType"
                      value="redevelopment"
                      onChange={handleFormInput}
                      className="d-none"
                    />
                    <span className="radio-btn">Re-development</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="saleType"
                      value="services"
                      onChange={handleFormInput}
                      className="d-none"
                    />
                    <span className="radio-btn">Services</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="saleType"
                      value="jointventures"
                      onChange={handleFormInput}
                      className="d-none"
                    />
                    <span className="radio-btn">Joint ventures</span>
                  </label>
                </div>
              </div>
              <div className="col-12">
                <span className="label">Property type</span>
                <div className="row radio-btn-group g-3">
                  {propertyTypes?.data?.map((type) => (
                    <label>
                      <input
                        type="radio"
                        name="propertyType"
                        value={type?.id}
                        onChange={(e) => {
                          handleFormInput(e);
                          setFormData((prev) => ({
                            ...prev,
                            step2: { ...prev?.step2, propertySubType: "" },
                          }));
                        }}
                        className="d-none"
                      />
                      <span className="radio-btn">{type?.name}</span>
                    </label>
                  ))}
                </div>
              </div>
              {!!propertySubTypes?.length && (
                <div className="col-12">
                  <span className="label">Property sub type</span>
                  <div className="row radio-btn-group g-3">
                    {propertySubTypes?.map((type) => (
                      <label>
                        <input
                          type="radio"
                          name="propertySubType"
                          value={type?.id}
                          onChange={handleFormInput}
                          className="d-none"
                          checked={formData?.step2?.propertySubType === type?.id?.toString()}
                        />
                        <span className="radio-btn">{type?.name}</span>
                      </label>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="d-flex justify-content-end">
              <button type="button" className="btn btn-light" onClick={previousStep}>
                Back
              </button>
              <button
                type="button"
                className="ms-3 btn btn-primary"
                onClick={nextStep}
                disabled={!isStepValid()}
              >
                Next
              </button>
            </div>
          </div>
          <div className={`card mt-2 ${isStepValid() || currentStep > 3 ? "" : ""}`}>
            <small className="text-muted">Step 3</small>
            <h6>CONFIGURATION</h6>
            <div className={`step row gy-4 ${currentStep === 3 ? "" : "d-none"}`}>
              <div className="col-lg-6">
                <label>
                  <span className="label">Configuration</span>
                  <Select
                    options={OPTIONS}
                    value={formData.step3?.configuration}
                    name="configuration"
                    placeholder="Configuration"
                    onChange={handleFormInput}
                  />
                </label>
              </div>
              <div className="col-lg-6">
                <label>
                  <span className="label">Furnished</span>
                  <Select
                    options={FURNISHED_OPTIONS}
                    value={formData.step3?.furnished}
                    name="furnished"
                    placeholder="Furnished"
                    onChange={handleFormInput}
                  />
                </label>
              </div>
              <div className="col-lg-6">
                <label>
                  <span className="label">Min Budget</span>
                  <input
                    className="form-control"
                    type="number"
                    name="min_bug"
                    value={formData.step3?.min_bug}
                    onChange={handleFormInput}
                  />
                </label>
              </div>
              <div className="col-lg-6">
                <label>
                  <span className="label">Max Budget</span>
                  <input
                    className="form-control"
                    type="number  "
                    name="max_bug"
                    value={formData.step3?.max_bug}
                    onChange={handleFormInput}
                  />
                </label>
              </div>
              <div className="col-lg-6">
                <label>
                  <span className="label">Location</span>
                  <input
                    className="form-control"
                    type="text"
                    name="location"
                    value={formData.step3?.location}
                    onChange={handleFormInput}
                  />
                </label>
              </div>
              <div className="col-lg-6">
                <label>
                  <span className="label">Purpose</span>
                  <Select
                    options={PURPOSE_OPTIONS}
                    value={formData.step3?.purpose}
                    name="purpose"
                    placeholder="Purpose"
                    onChange={handleFormInput}
                  />
                </label>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button type="button" className="btn btn-light" onClick={previousStep}>
                Back
              </button>
              <button
                type="button"
                className="ms-3 btn btn-primary"
                onClick={nextStep}
                disabled={!isStepValid()}
              >
                Next
              </button>
            </div>
          </div>
          <div className={`card mt-2 ${isStepValid() || currentStep > 4 ? "" : ""}`}>
            <small className="text-muted">Step 4</small>
            <h6>LEAD INFORMATION</h6>
            <div className={`step row gy-4 ${currentStep === 4 ? "" : "d-none"}`}>
              <div className="col-lg-6">
                <label>
                  <span className="label">Schedule Time</span>
                  <input
                    type="datetime-local"
                    name="scheduleTime"
                    className="form-control"
                    placeholder="Schedule Time"
                    value={formData.step4.scheduleTime}
                    onChange={handleFormInput}
                  ></input>
                </label>
              </div>
              <div className="col-lg-6">
                <label>
                  <span className="label">
                    Score <small className="text-muted">(choose between 0 to 100)</small>
                  </span>
                  <input
                    type="number"
                    max={100}
                    min={0}
                    name="score"
                    className="form-control"
                    placeholder="Score"
                    value={formData.step4.score}
                    onChange={handleFormInput}
                    onBlur={() =>
                      (formData.step4.score > 100 || formData.step4.score < 0) &&
                      setFormData((prev) => ({
                        ...prev,
                        step4: {
                          ...prev.step4,
                          score: 100,
                        },
                      }))
                    }
                  />
                </label>
              </div>
              <div className="col-lg-6">
                <label>
                  <span className="label">Source</span>
                  <Select
                    options={SOURCE_OPTIONS}
                    value={formData.step4.source}
                    name="source"
                    placeholder="Source"
                    onChange={handleFormInput}
                  />
                </label>
              </div>
              <div className="col-lg-6">
                <label>
                  <span className="label">Lead Type</span>
                  <Select
                    options={LEAD_TYPE_OPTIONS}
                    value={formData.step4.leadType}
                    name="leadType"
                    placeholder="Lead Type"
                    onChange={handleFormInput}
                  />
                </label>
              </div>
              <div className="col-lg-6">
                <label>
                  <span className="label">Assignee</span>
                  <Select
                    options={ASSIGNEE_OPTIONS}
                    value={formData.step4.assignee}
                    name="assignee"
                    placeholder="Assignee"
                    onChange={handleFormInput}
                  />
                </label>
              </div>
              <div className="col-12">
                <label>
                  <span className="label">Followup Note</span>
                  <textarea
                    name="followupNote"
                    placeholder="Followup Note"
                    className="form-control"
                    value={formData.step4.followupNote}
                    onChange={handleFormInput}
                  ></textarea>
                </label>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button type="button" className="btn btn-light" onClick={previousStep}>
                Back
              </button>
              <button type="submit" className="ms-3 btn btn-primary" disabled={!isStepValid()}>
                Submit
              </button>
            </div>
          </div>
        </form>
      </section>
      <CreateContactForm {...{ isOpen, onClose, getContacts }} />
    </>
  );
};

export default CreateLead;
